import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import { EspacioBlanco, required } from "@/commons/utils/Rules";
import "element-ui/lib/theme-chalk/display.css";
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument";
import { getFromLocal } from "@/commons/utils/storage";
export default {
  name: "PzPersonForm1Fucerep",
  components: {
    PzFormFlujo: PzFormFlujo,
    PzIdentityDocument: PzIdentityDocument
  },
  mixins: [PzBaseForm1],
  data: function data() {
    var _this = this;
    var check_telefono = function check_telefono(rule, value, callback) {
      var regla = "^(0)(\\d{8})$";
      var pattern = new RegExp(regla.toString());
      if (pattern.test(value)) {
        return callback();
      }
      return callback(new Error(_this.$t("rules.invalid_field", {
        name: rule.field
      })));
    };
    return {
      reference: "formulario1",
      tipo_credito: [{
        id: "renovacion",
        name: "Renovación"
      }, {
        id: "paralelo",
        name: "Paralelo"
      }],
      formulario1: {
        telefono: "",
        email: "",
        tipo_credito: "",
        monto_prestamo: "",
        cuotas: "",
        cuota_maxima: "",
        ingreso_mensual: "",
        destino_prestamo: "",
        identity: {
          document: 1
        },
        comprobante_domicilio: null,
        comprobante_ingresos: null,
        clearing: null,
        nombres: "",
        apellidos: ""
      },
      rules_formulario1: {
        "identity.document": [required("")],
        "identity.number": [required("")],
        telefono: [{
          validator: check_telefono,
          trigger: "blur"
        }],
        tipo_credito: [required("")],
        nombres: [required(""), EspacioBlanco()],
        apellidos: [required(""), EspacioBlanco()]
        /* tipo_credito: [required('')],
                    cuotas: [required('')],
                    monto_prestamo: [required('')],
                    cuota_maxima: [required(''),
                        type({field: '', type: 'number'}),],
                    ingreso_mensual: [required(''),
                        type({field: '', type: 'number'}),],
                    destino_prestamo: [required('')],
                  email: [
                    type({field: '', type: 'email'})
                  ]
                    email: [
                      type({field: '', type: 'email'})
                    ] */
      }
    };
  },
  created: function created() {
    this.$store.dispatch("loader/up", {
      trigger: this.$options.name
    });
    var docmun = localStorage.getItem("docnum");
    if (docmun) this.formulario1.identity.number = docmun;
    var data_client = getFromLocal("data_client");
    if (data_client) {
      this.formulario1.identity.document = data_client["tipo_documento"];
      this.formulario1.nombres = data_client["nombres"];
      this.formulario1.apellidos = data_client["apellidos"];
    }
    this.$store.dispatch("loader/down", {
      trigger: this.$options.name
    });
  },
  methods: {}
};